const FAIL_REASON_TO_ISSUE_KEY = {
  silence: "qualitySilence",
  no_speech: "qualityNoSpeech",
  noise: "qualityNoise",
};

export function getQualityIssueKey(audioQualityResult) {
  if (!audioQualityResult || audioQualityResult.passed !== false) {
    return null;
  }

  return FAIL_REASON_TO_ISSUE_KEY[audioQualityResult.failReason] ?? null;
}
